function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_135_1",
  "data-name": "Component 135 \\u2013 1",
  transform: "translate(0.5 0.448)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M43.728,68.7a1.779,1.779,0,0,1-1.812-1.821,1.825,1.825,0,0,1,1.812-1.826H68.335a1.825,1.825,0,0,1,1.816,1.826A1.783,1.783,0,0,1,68.335,68.7Zm16.145,10.63H43.728a1.823,1.823,0,0,1,0-3.646H59.873a1.823,1.823,0,0,1,0,3.646Zm-1.758,10.63H43.728a1.823,1.823,0,0,1,0-3.646H58.115a1.784,1.784,0,0,1,1.815,1.82A1.825,1.825,0,0,1,58.115,89.965ZM69,90.027a10.815,10.815,0,0,1-1.7-5.9A11.1,11.1,0,0,1,78.378,73.015a13.34,13.34,0,0,1,1.566.12V56.495a2.169,2.169,0,0,0-2.172-2.183H34.354a2.211,2.211,0,0,0-2.177,2.183V98.471a2.173,2.173,0,0,0,2.177,2.183H63.8l.3-2.606A11.626,11.626,0,0,1,69,90.023v0",
  transform: "translate(-32.177 -54.26)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_252",
  "data-name": "Rectangle 252",
  width: 48.06,
  height: 46.683,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M91.729,101.656A8.132,8.132,0,0,0,88.1,95.885a11.157,11.157,0,0,1-6.951,2.49,10.821,10.821,0,0,1-6.955-2.49,8.143,8.143,0,0,0-3.626,5.771l-.728,5.953a2.253,2.253,0,0,0,1.7,2.429,50.609,50.609,0,0,0,19.108,0,2.216,2.216,0,0,0,1.691-2.429l-.6-5.953",
  transform: "translate(-35.008 -57.387)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_253",
  "data-name": "Rectangle 253",
  width: 22.84,
  height: 15.51,
  transform: "translate(34.497 38.051)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M88.842,85.955a7.379,7.379,0,1,1-7.374-7.408,7.4,7.4,0,0,1,7.374,7.408",
  transform: "translate(-35.329 -56.083)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 1
}));

function SvgClaricalWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.345,
    height: 54.509,
    viewBox: "0 0 58.345 54.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaricalWork);
export default __webpack_public_path__ + "static/media/ClaricalWork.06b4f89d159a9f1f287ac031beca4e9d.svg";
export { ForwardRef as ReactComponent };